import { CardObserver } from './card.observer'
import { Observable } from 'rxjs'

export class CardComponent {
    constructor() {
        this.elements = document.querySelectorAll('.card')
        this.init()
    }

    init() {
        if(this.elements) {
            Array.prototype.forEach.call(this.elements, header => {
                let headerClickStream = Observable.fromEvent(header, 'click')
                headerClickStream
                    .debounceTime(400)
                    .map(event => event.target.parentElement.nextElementSibling)
                    .subscribe(new CardObserver())
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/card/card.component.js